import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  submitsave: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.submitsave',
    description: 'Text for the button used to submit and save changes to a form.',
    defaultMessage: 'Save and submit'
  },
  submit: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.submit',
    description: 'Text for the button used to submit a form.',
    defaultMessage: 'Submit'
  },
  save: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.save',
    description: 'Text for the button used to save a form when changes have been made.',
    defaultMessage: 'Save'
  },
  saved: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.saved',
    description: 'Text for the button used to save a form when there are no changes made.',
    defaultMessage: 'Saved'
  },
  cancel: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.cancel',
    description: 'Text for the button used to exit edit mode and discard changes made to a form.',
    defaultMessage: 'Cancel'
  },
  close: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.close',
    description: 'Text for the button used to exit edit mode when the form has not been changed.',
    defaultMessage: 'Close'
  }
});